export default __webpack_public_path__ + "static/thumb-landscape-93ce5c3b3510b8cedf61170b0edaf913.jpg";